/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { Logger } from 'fsts';
import { namespace } from 'vuex-class';
import { Contact } from '@/shared/model/contact';
import ModuleRoleTable from './module-role-table/module-role-table.vue';
import { GspUserRole, UserActiveServices } from '@/shared/model/gspUserRole';
import { GspUserRoleDetailInner } from '@/shared/model/gspUserRoleDetail';
import { OdataItems } from '@/shared/model/OdataItems';
import { GspService } from '@/shared/model/gspService';
import { VChip } from 'vuetify/lib';
import { ROUTES } from '@/router/routesEnum';
import { GspServiceKey } from '@/shared/utils/constants/services'

const logger = new Logger('contact-panel');
const authModule = namespace('auth');
const contactModule = namespace('contact');
const contactPanelModule = namespace('contactPanel');
const gspRoleModule = namespace('gspRole');
const gspUserRoleModule = namespace('gspUserRole');
const gspServiceModule = namespace('gspService');
const gspModuleModule = namespace('gspModule');
const gspUserRoleDetailModule = namespace('gspUserRoleDetail');

@Component({
  components: { ModuleRoleTable, VChip },
})
export default class ContactPanelView extends Vue {
  @gspServiceModule.Action('getGspServicesForContacts')
  private actionGetGspServices!: any;
  @gspServiceModule.Getter('getGspServicesForContacts')
  private getterGspServices!: GspService[];

  @authModule.Action('isInGroup')
  private actionIsInGroup!: any;
  @contactModule.Action('updateContactFreigabeZrPortal')
  private updateContactFreigabeZrPortal!: any;
  @authModule.Action('addRemoveInAzureZrPortalGroup')
  private actionAddRemoveInAzureZrPortalGroup!: any;

  @gspUserRoleModule.Action('updateGspUserRole')
  private actionUpdateGspUserRole!: any;
  @gspUserRoleModule.Getter('getGspUserRoles')
  private userRoles!: any;

  @gspUserRoleDetailModule.Action('checkContactInManageMaxByZrNummer')
  private checkContactInManageMaxByZrNummer!: any;

  @gspRoleModule.Getter('getGspRoles')
  private gspRoles!: any;

  @gspUserRoleModule.Getter('getUserActiveServices')
  private getUserActiveServices!: UserActiveServices[];

  @contactModule.Action('countActiveServices')
  private actionCountActiveServices!: any;
  @contactModule.Getter('getCountActiveServices')
  private getCountActiveServices!: number;


  @gspModuleModule.Getter('getModulesGroupedByService')
  private getterModulesGroupedByService!: any;

  private  GspServiceKey = GspServiceKey; // to use enum in template

  @Prop()
  private contact!: Contact;

  @Prop()
  private userRole!: GspUserRole;

  created() {}

  get isUsersUrl() {
    return this.$route.name == ROUTES.home;
  }
  get isSupplierUrl() {
    return this.$route.fullPath?.toLowerCase().includes('/supplier');
  }

  get zrPortalAzureId() {
    return this.servicesArr.find((x: any) => x.id == 4)?.entra_Group;
  }
  get vmeCommunityAzureId() {
    return this.servicesArr.find((x: any) => x.id == 7)?.entra_Group;
  }

  private isMultiZrService(item: any): boolean {
    return item?.zrType == 1 || item?.key === GspServiceKey.ZrStatNew; // (AD-305) cancel multi-ZR logic for `GspServiceKey.ZrStat`
  }

  private changeFreigabeSwitchForSupplier(e: any) {
    // console.log('zz zrPortalAzureId :>> ', this.zrPortalAzureId);
    // console.log('zz changeFreigabeSwitchForSupplier e :>> ',  e);
    // console.log('zz this :>> ', this);
    // console.log('zz this refs :>> ', this.$refs);
    const payload = {
      AzureUserId: this.contact.contactAzureId,
      AzureGroupId: this.zrPortalAzureId,
      IsFreigabe: this.contact.freigabe_zrportal,
    };

    this.actionAddRemoveInAzureZrPortalGroup(payload)
      .then((result: any) => {
        logger.log('zzz2 actionAddRemoveInAzureZrPortalGroup result :>> ', result);
        const supplierTableZrRefArr = (this.$refs as any).supplierTableZrRef;
        if (Array.isArray(supplierTableZrRefArr) && supplierTableZrRefArr.length > 0 && supplierTableZrRefArr[0]) {
          supplierTableZrRefArr[0].setFromParentSupplierSwitchZrPortal(this.contact.freigabe_zrportal);
        }

        if (['true', 'false'].includes(result?.result?.result?.toString().toLowerCase())) {
          this.contact.freigabe_zrportal = result.result.result;
        }
      })
      .catch((err: any) => {
        logger.error('zzz err :>> ', err);
      });
  }

  private changeFreigabeSwitchForContactVmeCommunity(e: any, setDbFreigabeAsTrue: boolean) {
    // thomas.kauer@kauer.ch
    // console.log('zz zrPortalAzureId :>> ', this.zrPortalAzureId);
    console.log('zz changeFreigabeSwitchForSupplier e :>> ', e);
    console.log('zz useTrueFreigabe :>> ', setDbFreigabeAsTrue);
    // console.log('zz this :>> ', this);
    // console.log('zz this refs :>> ', this.$refs);
    const payload = {
      AzureUserId: this.contact.contactAzureId,
      AzureGroupId: this.vmeCommunityAzureId,
      // (AD-223) we pass `freigabe_vme_community` from frontend (`false` - when Add, `true` when delete)
      IsFreigabe:
        this.contact.freigabe_vme_community == null || setDbFreigabeAsTrue
          ? false
          : this.contact.freigabe_vme_community,
      UseFreigabeVmeCommunity: true,
    };

    this.actionAddRemoveInAzureZrPortalGroup(payload)
      .then((result: any) => {
        logger.log('zz actionAddRemoveInAzureZrPortalGroup result :>> ', result);
        const contactSingleRowRef = (this.$refs as any).contactSingleRowRef;
        console.log('contactSingleRowRef :>> ', contactSingleRowRef);
        if (Array.isArray(contactSingleRowRef) && contactSingleRowRef.length > 0 && contactSingleRowRef[0]) {
          contactSingleRowRef[0].setFromParentSupplierSwitchVmeCommunity(this.contact.freigabe_vme_community);
        }

        // console.log('result?.result?.result :>> ', result?.result?.result);
        if (['true', 'false'].includes(result?.result?.result?.toString().toLowerCase())) {
          this.contact.freigabe_vme_community = result.result.result;
        }
      })
      .catch((err: any) => {
        logger.error('zzz err :>> ', err);
      });
  }

  addVmeCommunityGroup() {
    this.changeFreigabeSwitchForContactVmeCommunity(null, true);
  }

  // (AD-305) click handler for the ZrStatNew "fill all / clear all" switch.
  private changeFreigabeSwitchForZrStatNew(isCurrentlyEnabled: boolean) {
    // if it was ON -> user just clicked to turn it OFF -> clear all roles (isDelete = true)
    // if it was OFF -> user just clicked to turn it ON  -> fill all roles  (isDelete = false)
    const isDelete = isCurrentlyEnabled;

    // `multiZrTableRef` collects ALL multi-ZR ModuleRoleTable instances rendered
    // in this contact-panel (every service except ZrPortal, see :ref binding in
    // template), so we must find the one whose `service` prop is ZrStatNew.
    const multiZrTableRefArr = (this.$refs as any).multiZrTableRef;
    const zrStatNewTableRef = Array.isArray(multiZrTableRefArr)
      ? multiZrTableRefArr.find((x: any) => x.service?.key === GspServiceKey.ZrStatNew)
      : undefined;

    if (zrStatNewTableRef) {
      zrStatNewTableRef.setFromParentSwitchZrStatNew(isDelete);
    } else {
      logger.error('changeFreigabeSwitchForZrStatNew: cannot find ModuleRoleTable ref instance for ZrStatNew service');
    }
  }  

  private async getGspServices() {
    let contactType: string = '';
    if (this.isSupplierUrl) {
      contactType = 'supplier';
    } else if (this.$route.fullPath.includes('/intern')) {
      contactType = 'intern';
    }

    if (this.getterGspServices?.length > 0) {
      console.log('getGspServices getterGspServices :>> ', this.getterGspServices);
      this.servicesArr = this.getterGspServices;
    } else {
      await this.actionGetGspServices({ contactType: contactType })
        .then((result: any) => {
          console.log('getGspServices result :>> ', result);
          this.servicesArr = result;
        })
        .catch((err: any) => {
          logger.error(err);
        });
    }
  }
  private isManagerMax = false;

  servicesArr: any = [];
  // modulesArr: any = [];
  // attributesArr: any = [];

  get services() {
    return this.servicesArr?.items;
  }

  get contactData() {
    return {
      firstName: this.contact.firstName,
      lastName: this.contact.lastName,
      contactId: this.contact.recordID,
      contactAzureId: this.contact.contactAzureId,
      primaryCompany: this.contact.primary_Company_Hs_Object_Id,
      zrNummer: this.contact.primary_Company_Zr_Nummer,
      freigabeVmeCommunity: this.contact.freigabe_vme_community,
    };
  }

  moduleRoles: any = [];

  // get hasSelectedData() {
  //   const roleData = this.userRole.

  // }
  hasSelectedData(item: any) {
    // console.log('zzz item :>> ',  item);
    const isRoleHasDetails = this.userRole?.gspUserRoleDetails;
    const hasDetailsForThisService = this.userRole?.gspUserRoleDetails?.find((x: any) => x.serviceId === item.id);

    if (!isRoleHasDetails || !hasDetailsForThisService) return false;

    // !!TODO (AD-87) optimize this part by introducing calculated field in `GspUserRoleDetail`
    let result: any = { selected: false };
    if (hasDetailsForThisService.roleDetails) {
      let roleDetailData = hasDetailsForThisService.roleDetails as GspUserRoleDetailInner[];
      // AD-90 if `roleDetailData` is NULL do nothing and show stubs in accordions (contact-panels)
      if (roleDetailData.length === 0) {
        return result;
      }

      let moduleRoles = roleDetailData[0].moduleRoles?.filter((x: any) => (x.roles?.length ?? 0) > 0);
      const selectedZrNums = roleDetailData.filter(
        (x: any) => x.moduleRoles?.some((y: any) => y.roles?.length > 0)
      );

      // console.log('roleDetailData :>> ', roleDetailData);
      // console.log('roleDetailData[0] :>> ', roleDetailData[0]);
      if (this.isMultiZrService(item)) {
        let zrNums = roleDetailData.length ?? '-';
        // console.log('zrNums :>> ', zrNums);
        //  console.log('zzzz selectedZrNums :>> ', selectedZrNums);
        result.number = item.zrType == 1 ? 0 : selectedZrNums?.length ?? 0; // keep old `ZR-Portal` badge behavior // no count `avatar` in UI for `ZR-Portal`
        result.total = item.zrType == 1 ? 0 : zrNums; // 0 = no data
        result.text = this.$t('zr_number_amount', { zrNumbers: selectedZrNums?.length ?? '-', allZrNumbers: zrNums });
      } else {
        let allModules = roleDetailData[0].moduleRoles?.length ?? 0;
        // console.log('roleDetailData[0].moduleRoles.length :>> ', roleDetailData[0].moduleRoles?.length);
        //  console.log('zzz moduleRoles.length :>> ', moduleRoles?.length);

        // if (item.modules?.length > allModules) {
        //   // (AD-266) show correct number of modules (2) for `Blockverrechnung & Spotmarkt` service if only 1 filled in `GspUserRoleDetails`
        //   if (item.name?.toLowerCase()?.includes('spotmarkt')) {
        //     // console.log(`zzzz item.modules?.length ${item.modules?.length } > almodules :>>  ${allModules} , serviceId ${item.id}`);
        //     allModules = item.modules?.length;
        //   }
        // }
        const moduleCountsForService = this.getterModulesGroupedByService.find((x: any)=> x.serviceId == item.id)
        // console.log('zzz this.getterModulesGroupedByService :>> ',  this.getterModulesGroupedByService);
        console.log('zzz moduleCountsForService :>> ',  moduleCountsForService);

        result.number = moduleRoles?.length ?? 0;
        result.total =  moduleCountsForService?.moduleCount;//allModules;
        result.text = this.$t('module_amount', { moduleRoles: moduleRoles?.length ?? '-', allModuleRoles: allModules });
      }

      result.selected = this.isMultiZrService(item)
        ? selectedZrNums.length > 0
        : (moduleRoles?.length ?? 0) > 0;
    }
    console.log('result hasSelectedData :>> ', result);
    return result;
  }

  async mounted() {
    // console.log('cp m1 this.userRole :>> ', this.userRole);
    // console.log('cp m2 js this.userRole :>> ', JSON.stringify(this.userRole));
    logger.debug('mounted contact-panel');
    try {
      // ds, 17.04.2026 -> AD-223 in agreement with Kedas Ch., the code has been temporarily commented out because it did not always return correct values.
      // if (this.isSupplierUrl) {
      //   // (AD-223) do nothing for user with type `supplier`
      // } else {
      //   this.actionIsInGroup(this.contact.email)
      //     .then((result: any) => {
      //       logger.log('result :>> ', result);
      //       const payload = {
      //         email: this.contact.email,
      //         isActive: !!result && result > 0,
      //       };
      //       this.updateContactFreigabeZrPortal(payload).then((result: any) => {
      //         logger.log('updateContactFreigabeZrPortal result :>> ', result);
      //         // console.log('zzzz result.result.freigabe_zrportal :>> ',  result.result.freigabe_zrportal);
      //         if (result.result) {
      //           this.contact.freigabe_zrportal = result.result.freigabe_zrportal;
      //         }
      //       });
      //     })
      //     .catch((err: any) => {
      //       logger.error(err);
      //     });
      // }

      if (this.isSupplierUrl) {
        // NO `ManageMax` user for `supplier`
      } else {
        // this.isManagerMax = true; // !! FOR_LOCAL_DEVELOPMENT
        if (this.contact.email?.toLowerCase().includes('vmetest_')) {
          this.isManagerMax = true;
        }
        // (AD-171) check if `Contact` in ManagerMax via API call
        this.checkContactInManageMaxByZrNummer({ zrNummer: this.zrNumberArr?.join(',') + '' })
          .then((result: any) => {
            logger.log('result :>> checkContactInManageMaxByZrNummer', result);
            if (result.result) {
              this.isManagerMax = true;
            }
            // this.isManagerMax = true; // !! FOR_LOCAL_DEVELOPMENT
          })
          .catch((err: any) => {
            logger.error(err);
          });
      }
    } catch (error) {
      logger.error(error);
    }

    var promiseAll = [this.getGspServices()];
    await Promise.all(promiseAll);
    // const result = this.userRoles.items.find((role:any) => role.contactEmail == this.contact.email);
    // console.log('mounted userRole result :>> ', result);
    // console.log('mounted  contact:>> ', this.contact.email);

    this.updateUserRoleData();
  }

  @Watch('userRole')
  updateUserRoleData() {
    logger.debug('----- updateUserRolesData ---------');

    if (this.userRole?.zrNumRolesData) {
      this.userRoleData = JSON.parse(this.userRole?.zrNumRolesData);

      this.userRoleData.forEach((element: any, index) => {
        if (element?.zrNummer) {
          Vue.set(this.boxes, index, true);
          Vue.set(this.roleBoxes, index, element.roles);
        }
      });
      this.userRolesPayload = this.userRoleData;
    }
  }

  //#region
  isSaving = false;
  userRolesPayload: any = [];

  boxes: Array<boolean> = [false];
  roleBoxes: Array<any> = [];
  userRoleData = [];

  get zrNumberArr() {
    return this.contact.companyZrNumber?.split(',')?.map((x) => x.trim()) || [];
  }

  // get userRole() {
  //   const result = this.userRoles.items.find((role: any) => role.contactEmail == this.contact.email);
  //   return result;
  // }

  get roles() {
    return this.gspRoles.items;
  }
  not(e: any) {
    e.preventDefault();
    e.stopPropagation();

    console.log('e :>> ', e);
  }

  changeZrNumbBox(ev: any, item: any, i: any) {
    console.log('ev :>> ', ev);
    console.log('item :>> ', item);
    console.log('i :>> ', i);
    console.log('this.gspRoles :>> ', this.gspRoles);
    if (!ev) {
      this.removeZrNumRole('zrNum', i);
    }
  }

  removeZrNumRole(source: any, index: number) {
    this.userRolesPayload[index] = null;
    if (source == 'zrNum') {
      Vue.set(this.roleBoxes, index, null);
    }
  }

  changeRole(ev: any, item: any, i: any) {
    if (ev.length == 0) {
      this.removeZrNumRole('role', i);
    }
    console.log('ev :>> ', ev);
    console.log('item :>> ', item);
    console.log('i zr :>> ', i);

    let obj = { zrNummer: item.trim(), roles: ev };
    this.userRolesPayload[i] = obj;
    // this.boxes[i] = ev.length>0 ;
    Vue.set(this.boxes, i, ev.length > 0);

    // Array.prototype.splice
    // vm.items.splice(indexOfItem, 1, newValue)
  }

  save() {
    console.log('save roles:>> ');

    const payload = {
      id: this.userRole?.id || undefined,
      contactId: this.contact.recordID,
      contactEmail: this.contact.email,

      zrNumRolesData: JSON.stringify(this.userRolesPayload),
    };
    console.log('payload :>> ', payload);

    this.actionUpdateGspUserRole(payload);
  }
  //#endregion

  onEditModuleRole(contactId: any) {
    let contactType: number = 1;
    if (this.isSupplierUrl) {
      contactType = 2;
    } else if (this.$route.fullPath.includes('/intern')) {
      contactType = 3;
    }
    this.actionCountActiveServices({ contactId: contactId, contactType: contactType });
  }
}
